/**
 * The default `advanced.footer.fields` shape, shared by createPresentationNextOption (fresh v2
 * presentations) and convertPresentationV1ToV2 (converted ones) so the two default values can't
 * drift apart — only `show` differs between the two call sites.
 */
export function getDefaultFooterFields(): { leftText: string; rightText: string; columnAlign: 'center' } {
  return {
    leftText: '',
    rightText: '',
    columnAlign: 'center'
  }
}
